export default __webpack_public_path__ + "locales/en/Errors.json?hash=79c7fb521e869f1478acb546dce78b59";